import { lazy, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import "./index.css";

import LoginPage from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import SignUp from "./pages/SignUp";
import RequireAuth from "./components/RequireAuth";
import { canManageScheduleV2 } from "./pages/scheduleV2/scheduleV2Permissions";
import RedirigirRutaAnterior from "./pages/geofence/RedirigirRutaAnterior";
import { CLAVES_DE_SECCION, RUTAS_ANTERIORES, rutaDeSeccion } from "./pages/geofence/rutasGeofence";
const HomePage = lazy(() => import("./pages/Home"));
const ScheduleV2Page = lazy(() => import("./pages/scheduleV2/ScheduleV2Page"));
const DispatchBoardPage = lazy(() => import("./pages/scheduleV2/DispatchBoardPage"));
const FseCapacityPage = lazy(() => import("./pages/scheduleV2/FseCapacityPage"));
const FSEWeekBoardPage = lazy(() => import("./pages/scheduleV2/FSEWeekBoardPage"));
const ScheduleV2SettingsPage = lazy(() => import("./pages/scheduleV2/ScheduleV2SettingsPage"));
const ScheduleV2TemplatesPage = lazy(() => import("./pages/scheduleV2/ScheduleV2TemplatesPage"));
const NewTicketView = lazy(() => import("./pages/tickets/newTicketView"));
const TicketsAdminView = lazy(() => import("./pages/tickets/AdminView"));
const Ticket = lazy(() => import("./components/ui/Ticket"));
const TicketsDashboard = lazy(() => import("./pages/tickets/TicketsDashboard"));
const TicketsUsersTable = lazy(() => import("./pages/tickets/TicketsUsersTable"));
const TicketUser = lazy(() => import("./components/ui/TicketUser"));
const UsersViewer = lazy(() => import("./pages/users_viwer/UsersViewer"));
const BudgetUser = lazy(() => import("./layouts/BudgetUser"));
const InvoiceUser = lazy(() => import("./layouts/InvoiceUser"));
const UserHome = lazy(() => import("./layouts/UserHome"));
const ExpenseHistorical = lazy(() => import("./layouts/ExpenseHistorical"));
const LcuPartnumbers = lazy(() => import("./pages/warehouse/LcuPartnumbers"));
const LcuBom = lazy(() => import("./pages/warehouse/LcuBom"));
const LcuDelivery = lazy(() => import("./pages/warehouse/LcuDelivery"));
const LcuCPU = lazy(() => import("./pages/warehouse/LcuCPU"));
const LcuBox = lazy(() => import("./pages/warehouse/LcuBox"));
const ImmexPartnumbers = lazy(() => import("./pages/immex/ImmexPartnumbers"));
const ImmexPedimento = lazy(() => import("./pages/immex/ImmexPedimento"));
const ImmexCheckout = lazy(() => import("./pages/immex/ImmexCheckout"));
const ImmexLocation = lazy(() => import("./pages/immex/ImmexLocation"));
const ImmexPartidas = lazy(() => import("./pages/immex/ImmexPartidas"));
const ProfileView = lazy(() => import("./pages/profile/profileView"));
const Test = lazy(() => import("./pages/test"));
const ReportsCharts = lazy(() => import("./pages/charts/ReportsCharts"));
const JigsView = lazy(() => import("./pages/jigs/JigsView"));
const PurchaseOrders = lazy(() => import("./pages/po/PurchaseOrders"));
const ClientsTableNew = lazy(() => import("./pages/utils/ClientsTableNew"));
const EmployeesTable = lazy(() => import("./pages/utils/EmployeesTable"));
const UsersTable = lazy(() => import("./pages/utils/UsersTable"));
const EmailLogsPage = lazy(() => import("./pages/utils/EmailLogsPage"));
const TycTable = lazy(() => import("./pages/utils/TycTable"));
const Jobs = lazy(() => import("./pages/utils/Jobs"));
const AreaCoordinationPage = lazy(() => import("./pages/utils/AreaCoordinationPage"));
const PublicImagesUploadPage = lazy(() => import("./pages/utils/PublicImagesUploadPage"));
const JigsTable = lazy(() => import("./pages/jigs/JigsTable"));
const QuotesTable = lazy(() => import("./pages/quotes/QuotesTable"));
const CreateQuote = lazy(() => import("./pages/quotes/CreateQuote"));
const QuoteDashboard = lazy(() => import("./pages/quotes/QuoteDashboard"));
const JigsDashboard = lazy(() => import("./pages/jigs/JigsDashboard"));
const ChangeLog = lazy(() => import("./pages/utils/ChangeLog"));
const HeadViewer = lazy(() => import("./pages/heads/HeadViewer"));
const SRMCharts = lazy(() => import("./pages/srm/SRMCharts"));
const SRMDashboard = lazy(() => import("./pages/srm/SRMDashboard"));
const WorkFlow = lazy(() => import("./pages/workflow/WorkFlow"));
const PoCharts = lazy(() => import("./pages/po/PoCharts"));
const PoDashboard = lazy(() => import("./pages/po/PoDashboard"));
const PoTransactionsPage = lazy(() => import("./pages/po/PoTransactionsPage"));
const SRMTableView = lazy(() => import("./pages/srm/SRMTableView"));
const SRMOfflineReportsPage = lazy(() => import("./pages/srm/SRMOfflineReportsPage"));
const SRMChartsNew = lazy(() => import("./pages/srm/SRMChartsNew"));
const SRMAreaAssignmentPage = lazy(() => import("./pages/srm/SRMAreaAssignmentPage"));
const SRMCoordinatorAssignmentPage = lazy(() => import("./pages/srm/SRMCoordinatorAssignmentPage"));
const SRMTechnicalInsightsPage = lazy(() => import("./pages/srm/SRMTechnicalInsightsPage"));
const SRMFseInsightsPage = lazy(() => import("./pages/srm/SRMFseInsightsPage"));
const LogAnalyzerPage = lazy(() => import("./pages/logAnalyzer/LogAnalyzerPage"));
const DOC = lazy(() => import("./pages/operacionesComercio/DOC"));
const ReportsTableLegacy = lazy(() => import("./pages/charts/ReportsTableLegacy"));
const CalendarPage = lazy(() => import("./pages/training/CalendarPage"));
const CoursesTablePage = lazy(() => import("./pages/training/CoursesTablePage"));
const CoursesOldPage = lazy(() => import("./pages/training/CoursesOldPage"));
const TrainingDashboard = lazy(() => import("./pages/training/TrainingDashboard"));
const TrainingSummaryPage = lazy(() => import("./pages/training/TrainingSummaryPage"));
const TrainingUsersPage = lazy(() => import("./pages/training/TrainingUsersPage"));
const TrainingSuggestionsPage = lazy(() => import("./pages/training/TrainingSuggestionsPage"));
const CompletedCoursesPage = lazy(() => import("./pages/training/CompletedCoursesPage"));
const TrainingCreditsPage = lazy(() => import("./pages/training/TrainingCreditsPage"));
const TrainingMyUsersPage = lazy(() => import("./pages/training/TrainingMyUsersPage"));
const TrainingEmailSettingsPage = lazy(() => import("./pages/training/TrainingEmailSettingsPage"));
const ActionTrackersPage = lazy(() => import("./pages/tickets/ActionTrackersPage"));
const ActionTrackers2026Page = lazy(() => import("./pages/tickets/ActionTrackers2026Page"));
// Las doce vistas de Geofence se cargan desde su sección, una por pestaña.
const GeofenceSeccionPage = lazy(() => import("./pages/geofence/GeofenceSeccionPage"));
const MachineTracker = lazy(() => import("./pages/warehouse/MachineTracker"));


const ROLES = {
	user: "user",
	client: "client",
	Admin: 5150,
};

/*const socket = io.connect(process.env.REACT_APP_API_SOCKET, {
	cors: { origin: "*" },
});
console.log("socket ", socket);*/
const socket=null;

const canAccessGeofence = () => {
	try {
		const raw = localStorage.getItem("appMemberships");
		const memberships = raw ? JSON.parse(raw) : {};
		return String(memberships?.geofence || "").toLowerCase() === "admin";
	} catch (_) {
		return false;
	}
};

const GeofenceAdminRoute = ({ element }) => {
	return canAccessGeofence() ? element : <Navigate to="/dashboard" replace />;
};

const ScheduleV2AdminRoute = ({ element }) => {
	return canManageScheduleV2() ? element : <Navigate to="/schedule-v2" replace />;
};

const canAccessUtilsAdmin = () => {
	try {
		const raw = localStorage.getItem("appMemberships");
		const memberships = raw ? JSON.parse(raw) : {};
		return String(memberships?.utils || "").toLowerCase() === "admin";
	} catch (_) {
		return false;
	}
};

const UtilsAdminRoute = ({ element }) => {
	return canAccessUtilsAdmin() ? element : <Navigate to="/dashboard" replace />;
};

export const canAccessSrmInsights = () => {
	try {
		const raw = localStorage.getItem("appMemberships");
		const memberships = raw ? JSON.parse(raw) : {};
		const reportsRole = String(memberships?.reports || "").toLowerCase();
		const reportsAppRole = String(memberships?.reportsApp || "").toLowerCase();
		return reportsRole === "admin" || reportsAppRole === "admin";
	} catch (_) {
		return false;
	}
};

const SrmInsightsRoute = ({ element }) => {
	return canAccessSrmInsights() ? element : <Navigate to="/SRM/table" replace />;
};

function App() {
	return (
	<Suspense fallback={<div className="min-h-screen grid place-items-center text-slate-500">Loading...</div>}>
	<Routes>
		{/* public routes */}
		<Route path="/" element={<LoginPage />} />
		<Route path="/signup" element={<SignUp />} />
		<Route path="/reset-password" element={<ResetPassword />} />

		{/* private routes */}
		<Route element={<RequireAuth allowedRoles={[ROLES.user]} />}>
			<Route path="/dashboard" element={<HomePage />} />
			<Route path="/schedule/admin" element={<Navigate to="/schedule-v2" replace />} />
			<Route path="/schedule/user" element={<Navigate to="/schedule-v2" replace />} />
			<Route path="/schedule-v2" element={<ScheduleV2Page />} />
			<Route path="/schedule-v2/dispatch" element={<ScheduleV2AdminRoute element={<DispatchBoardPage />} />} />
			<Route path="/schedule-v2/capacity" element={<ScheduleV2AdminRoute element={<FseCapacityPage />} />} />
			<Route path="/schedule-v2/week-board" element={<ScheduleV2AdminRoute element={<FSEWeekBoardPage />} />} />
			<Route path="/schedule-v2/settings" element={<ScheduleV2AdminRoute element={<ScheduleV2SettingsPage />} />} />
			<Route path="/schedule-v2/templates" element={<ScheduleV2TemplatesPage />} />
			<Route path="/tickets/new" element={<NewTicketView />} />
			<Route path="/profile" element={<ProfileView />} />
			<Route path="/test" element={<Test />} />
			<Route path="/tickets/admin" element={<TicketsAdminView socket={socket} />} />
			<Route path="/tickets/admin/ticket" element={<Ticket />} />
			<Route path="/tickets/dashboard" element={<TicketsDashboard />} />
			<Route path="/tickets/usersTable" element={<TicketsUsersTable />} />
			<Route path="/tickets/user" element={<TicketsAdminView socket={socket} />} />
			<Route path="/tickets/user/ticket" element={<TicketUser />} />
			<Route path="/reportsLegacy/charts" element={<ReportsCharts />} />
			<Route path="/reportsLegacy/table" element={<ReportsTableLegacy />} />

			<Route path="/po/table" element={<PurchaseOrders />} />
			<Route path="/po/charts" element={<PoCharts />} />
			<Route path="/po/dashboard" element={<PoDashboard />} />
			<Route path="/po/transactions" element={<PoTransactionsPage />} />

			<Route path="/user/home" element={<UserHome />} />
			<Route path="/user/budget" element={<BudgetUser />} />
			<Route path="/user/expense" element={<InvoiceUser />} />
			<Route path="/user/viewer" element={<UsersViewer />} />
			<Route path="/user/historical" element={<ExpenseHistorical />} />

			<Route path="/jigs" element={<JigsView />} />
			<Route path="/jigsTable" element={<JigsTable />} />
			<Route path="/jigsDashboard" element={<JigsDashboard />} />

			<Route path="/warehouse/partnumber" element={<LcuPartnumbers />} />
			<Route path="/warehouse/bom" element={<LcuBom />} />
			<Route path="/warehouse/delivery" element={<LcuDelivery />} />
			<Route path="/warehouse/cpu" element={<LcuCPU />} />
			<Route path="/warehouse/lcubox" element={<LcuBox />} />

			<Route path="/immex/pedimento" element={<ImmexPedimento />} />
			<Route path="/immex/partnumber" element={<ImmexPartnumbers />} />
			<Route path="/immex/checkout" element={<ImmexCheckout />} />
			<Route path="/immex/location" element={<ImmexLocation />} />
			<Route path="/immex/partida" element={<ImmexPartidas />} />
			<Route path="/warehouse/machinetracker" element={<MachineTracker />} />

			<Route path="/heads/headviwer" element={<HeadViewer />} />

			<Route path="/utils/clients" element={<Navigate to="/utils/clients-new" replace />} />
			<Route path="/utils/clients-new" element={<ClientsTableNew />} />
			<Route path="/utils/users" element={<UsersTable />} />
			<Route path="/utils/email-logs" element={<UtilsAdminRoute element={<EmailLogsPage />} />} />
			<Route path="/utils/employees" element={<EmployeesTable />} />
			<Route path="/utils/area-coordination" element={<AreaCoordinationPage />} />
			<Route path="/SRM/area-coordination" element={<AreaCoordinationPage />} />
			<Route path="/utils/public-images" element={<PublicImagesUploadPage />} />
			<Route path="/utils/tyc" element={<TycTable />} />
			<Route path="/utils/jobs" element={<Jobs />} />
			<Route path="/utils/changeLog/:appName" element={<ChangeLog />} />
			<Route path="/log-analyzer" element={<LogAnalyzerPage />} />

			<Route path="/workflow" element={<WorkFlow />} />
			<Route path="/workflow/my-reported" element={<WorkFlow defaultScope="my-reported" />} />
			<Route path="/workflow/my-assigned" element={<WorkFlow defaultScope="my-assigned" />} />
			<Route path="/workflow/roadmap" element={<WorkFlow defaultScope="roadmap" />} />
			<Route path="/workflow/board" element={<WorkFlow defaultView="board" />} />

			<Route path="/quotes" element={<QuotesTable />} />
			<Route path="/quotes/dashboard" element={<QuoteDashboard />} />
			<Route path="/quotes/create" element={<CreateQuote />} />

			<Route path="/SRM/table" element={<SRMTableView />} />
			<Route path="/SRM/offline-reports" element={<SRMOfflineReportsPage />} />
			<Route path="/SRM/dashboard" element={<SRMDashboard />} />
			<Route path="/SRM/charts" element={<SRMCharts />} />
			<Route path="/SRM/assign-areas" element={<SRMAreaAssignmentPage />} />
			<Route path="/SRM/assign-coordinators" element={<SRMCoordinatorAssignmentPage />} />
			<Route path="/SRM/technical-insights" element={<SrmInsightsRoute element={<SRMTechnicalInsightsPage />} />} />
			<Route path="/SRM/fse-insights" element={<SrmInsightsRoute element={<SRMFseInsightsPage />} />} />

			<Route path="/SRM/chartsnew" element={<SRMChartsNew />} />

			<Route path="/OperacionesComercio/Dashboard" element={<DOC />} />

			<Route path="/training/calendar" element={<CalendarPage />} />
			<Route path="/training/courses" element={<CoursesTablePage />} />
			<Route path="/training/courses-old" element={<CoursesOldPage />} />
			<Route path="/training/dashboard" element={<TrainingDashboard />} />
			<Route path="/training/summary" element={<TrainingSummaryPage />} />
			<Route path="/training/users" element={<TrainingUsersPage />} />
			<Route path="/training/suggestions" element={<TrainingSuggestionsPage />} />
			<Route path="/training/completed" element={<CompletedCoursesPage />} />
			<Route path="/training/credits" element={<TrainingCreditsPage />} />
			<Route path="/training/my-users" element={<TrainingMyUsersPage />} />
			<Route path="/training/email-settings" element={<TrainingEmailSettingsPage />} />
			{CLAVES_DE_SECCION.map(clave => (
				<Route
					key={clave}
					path={rutaDeSeccion(clave)}
					element={<GeofenceAdminRoute element={<GeofenceSeccionPage seccion={clave} />} />}
				/>
			))}
			{/* Las doce rutas de antes de agrupar en secciones. */}
			{Object.keys(RUTAS_ANTERIORES).map(ruta => (
				<Route key={ruta} path={ruta} element={<RedirigirRutaAnterior ruta={ruta} />} />
			))}
			<Route path="/tickets/action-trackers" element={<ActionTrackersPage />} />
			<Route path="/tickets/action-trackers-2026" element={<ActionTrackers2026Page />} />
		</Route>

		{/* catch all */}
		<Route path="*" element={<LoginPage />} />
	</Routes>
	</Suspense>
);
}

export default App;

/*<Route element={<RequireAuth allowedRoles={[ROLES.client]} />}>
					<Route path="editor" element={<Editor />} />
				</Route>*/

/*const getUserData = () =>
	new Promise(resolve =>
		setTimeout(() => {
			const user = window.localStorage.getItem("user");
			console.log(user);
			const user2 = { user: "dsa" };
			resolve(user2);
		}, 3000)
	);

// for error
// const getUserData = () =>
//   new Promise((resolve, reject) =>
//     setTimeout(() => {
//       reject("Error");
//     }, 3000)
//   );

export const router = createBrowserRouter(
	createRoutesFromElements(
		<Route
			element={<AuthLayout />}
			loader={() => defer({ userPromise: getUserData() })}
		>
			<Route path="/" element={<LoginPage />} />

			<Route path="/dashboard" element={<ProtectedLayout />}>
				<Route index element={<HomePage />} />
				<Route path="profile" element={<HomePage />} />
			</Route>

			<Route path="*" element={<Error404 />} />
		</Route>
	)
);*/
